import { AudienceOptions, SendOptions } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  title: 'Creare campanie de notificări push',
  sent_title: 'Notificare în coadă',
  sent_subtitle:
    'Notificarea push a fost trimisă la Apple și Google. Confirmările de livrare sosesc în aproximativ 15 minute.',
  sent_info_banner:
    'Puteți închide acest dialog. Vom continua să verificăm și să actualizăm automat statisticile de livrare ale campaniei.',
  circles: {
    sent_label: 'Trimis',
    sent_sub: 'Trimis abonaților',
    delivered_label: 'Livrat',
    delivered_sub: 'În așteptarea Apple & Google',
    delivered_ready_short: 'Gata',
    delivered_ready_sub: 'Actualizați pentru a vedea ultimele statistici',
  },
  scheduled_title: 'Campanie programată',
  scheduled_body_line_1: 'Notificarea push este programată pentru {{when}}.',
  scheduled_body_line_2:
    'O vom trimite automat la acel moment. Confirmările de livrare de la Apple și Google devin disponibile la aproximativ 15 minute după trimitere.',
  recipients_count_one: 'Trimis la {{count}} abonat.',
  recipients_count_few: 'Trimis la {{count}} abonați.',
  recipients_count_other: 'Trimis la {{count}} abonați.',
  close: 'Închide',
  sections: {
    message: 'Mesaj',
    audience: 'Audiență',
    when: 'Când să trimiți',
    review: 'Revizuire',
  },
  stepper: {
    message: 'Mesaj',
    audience_when: 'Când să trimiți',
    review: 'Revizuire',
  },
  blocked_reasons: {
    title_required: 'Adăugați un titlu pentru a continua.',
    body_required: 'Adăugați un corp de mesaj pentru a continua.',
    offer_required: 'Selectați o ofertă pentru a continua.',
    promo_code_required: 'Selectați un cod promoțional pentru a continua.',
    send_option_required: 'Alegeți când să trimiteți pentru a continua.',
    scheduled_at_required: 'Selectați o dată și oră pentru a continua.',
  },
  fields: {
    title: {
      label: 'Titlu',
      placeholder: 'Introduceți titlul notificării',
    },
    body: {
      label: 'Corp mesaj',
      placeholder: 'Introduceți mesajul dvs.',
    },
    audience: {
      label: 'Audiență',
    },
    send_options: {
      label: 'Opțiuni trimitere',
    },
    date_and_time: {
      label: 'Dată și oră',
      placeholder: 'Selectați data și ora',
    },
  },
  send_options: {
    [SendOptions.Now]: 'Trimite acum',
    [SendOptions.Schedule]: 'Programare',
  },
  send_option_cards: {
    now: {
      title: 'Trimite acum',
      description: 'Trimite tuturor abonaților imediat.',
    },
    schedule: {
      title: 'Programare',
      description: 'Selectați o dată și oră în viitor.',
    },
  },
  campaign_type_cards: {
    promotional: {
      title: 'Promoțional 🚀',
      description: 'Promovați o ofertă sau un cod promoțional.',
    },
    informational: {
      title: 'Informațional ℹ️',
      description: 'Împărtășiți știri sau o actualizare — fără reducere atașată.',
    },
  },
  audience: {
    [AudienceOptions.All]: 'Toți utilizatorii ({{count}} dispozitiv)',
  },
  preview: {
    title: 'Previzualizare',
    notifications: {
      title: 'Titlul notificării va apărea aici',
      body: 'Corpul mesajului va fi afișat aici cu toate detaliile...',
      now: 'Acum',
    },
    estimated_reach: 'Acoperire',
  },
  summary: {
    title: 'Sumar',
    reach: 'Acoperire',
    when: 'Când',
    campaign_type: 'Tip campanie',
    promo_code: 'Cod promoțional',
    offer: 'Ofertă',
    test_audience: 'Trimiteți mai întâi un push de test',
  },
  alerts: {
    daily_limit_reached: {
      title: 'Limita zilnică de trimitere atinsă',
      description:
        'Hei! Trimiterea mai mult de 1 notificare push pe zi îi nemulțumește pe utilizatori și poate duce la ștergerea aplicației. De aceea limităm notificările manuale la 1/zi. Vă rugăm programați aceasta pentru mâine.',
    },
    offer_not_sendable: {
      title: 'Oferta nu este valabilă azi',
      description: 'Vă rugăm alegeți o dată în viitor.',
    },
  },
  buttons: {
    send_now: 'Trimite acum',
    save: 'Salvează',
    save_as_draft: 'Salvează ca ciornă',
    send_test: 'Trimite test',
    draft_with_ai: 'Schiță cu AI',
    back: 'Înapoi',
    next: 'Următor',
  },
  feedback: {
    success: 'Campanie salvată cu succes',
    promo_code_expired: 'Cod promoțional expirat',
    error: 'Campania nu a putut fi salvată. Verifică conexiunea și încearcă din nou.',
  },
};
